import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { useFormikContext } from 'formik';

import styles from './CustomSelect.module.scss';

const CustomSelect = ({
  name,
  placeholder,
  className,
  disabled = false,
  data = null,
  options,
  isSearchable = false,
}) => {
  const { values, setValues } = useFormikContext();
  const [selectedValue, setSelectedValue] = useState(null);
  const [componentIsFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (data) {
      setSelectedValue({ value: data, label: data });
    }
  }, [data]);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleOnchange = (option) => {
    if (option) {
      setSelectedValue({ value: option.value, label: option.value });
      setValues({ ...values, [name]: option.value.toString() });
    }
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      border: '1px solid #BFBFBF',
      height: 40,
      paddingLeft: '10px',
      paddingRight: '10px',
      textAlign: 'left',
      boxShadow: 'none',
      '&:hover': { border: '1px solid #BFBFBF' },
    }),
    option: (base, { isFocused }) => ({
      ...base,
      backgroundColor: isFocused ? 'rgba(0, 109, 228, 0.1)' : '#fff',
      color: '#343741',
    }),
    multiValue: () => ({ display: 'none' }),
    valueContainer: (base) => ({
      ...base,
      fontSize: '14px',
      lineHeight: '16px',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
  };

  return (
    <div className={`${styles.container} ${className}`}>
      <span className="blocking-span">
        <ReactSelect
          value={selectedValue}
          styles={customStyles}
          className="basic-single"
          classNamePrefix="select"
          placeholder=""
          name={name}
          options={options}
          isDisabled={disabled}
          onChange={(option) => handleOnchange(option)}
          onFocus={handleFocus}
          onBlur={handleBlur}
          isSearchable={isSearchable}
        />
        <span className={selectedValue || componentIsFocused ? styles.floatingLabelFocused : styles.floatingLabel}>
          {placeholder}
        </span>
      </span>
    </div>
  );
};

export default CustomSelect;
